import { createIconComponent } from '../../factory/create-icon-component';
export const MaximizeIcon = createIconComponent(
  'MaximizeIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 21V15M3 21H9M3 21L6.5 17.5L8 16M21 3V9M21 3H15M21 3L17.5 6.5L16 8"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
